export default "__VITE_ASSET__DZ_hn2kM__"